import { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
import { useDispatch, useSelector } from 'react-redux'
import { adminAction } from '../../../redux/common/action'
import { Link } from 'react-router-dom'
import { URL } from '../../../redux/common/url'
import { AsyncPaginate } from 'react-select-async-paginate'

interface Option {
    value: string
    label: string
}
interface PaginatedResponse {
    results: Option[]
    has_more: boolean
}

function OldReports() {
    const [pageCount, setPageCount] = useState(0);
    const [pageNo, setpageNo] = useState<any>(1);
    const [search, setSearch] = useState<string>('');

    const dispatch = useDispatch()
    const get_old_reports_list: any = useSelector((state: any) =>
        state.admin.old_reports_list ? state.admin.old_reports_list : {}
    )

    const reportData = get_old_reports_list?.data ? get_old_reports_list?.data : []
    const totalDocs = get_old_reports_list?.total || 0

    useEffect(() => {
        setPageCount(Math.ceil(totalDocs / 10))
    }, [totalDocs])

    const handlePageClick = (event: any) => {
        const data = event?.selected + 1
        setpageNo(data)
    }

    // Get user from localStorage
    const getUserFromToken = () => {
        const token = localStorage.getItem('kt-auth-react-v')
        if (token) {
            try {
                return JSON.parse(token)?.data
            } catch {
                return null
            }
        }
        return null
    }

    const user = getUserFromToken()
    const prefix = user?.prefix || ''
    const isJen = prefix === 'jens'
    const isAen = prefix === 'aens'
    const isXen = prefix === 'xens'
    const isAdmin = !['xens', 'aens', 'jens'].includes(prefix) // <--- NEW: Admin or other role

    // Fixed IDs from token
    const circleId = user?.circle_id?.toString() || ''

    // For non-admin roles
    const xenId = isXen ? user?.id?.toString() : (user?.xen_id?.toString() || '')
    const aenId = isAen ? user?.id?.toString() : (user?.aen_id?.toString() || '')

    // Selectable states
    const [selectedXen, setSelectedXen] = useState<any>({})
    const [selectedAen, setSelectedAen] = useState<any>({})
    const [selectedJen, setSelectedJen] = useState<any>({})

    const [managerKeyXen, setManagerKeyXen] = useState<any>(0)
    const [managerKeyAen, setManagerKeyAen] = useState<any>(0)
    const [managerKeyJen, setManagerKeyJen] = useState<any>(0)

    // Reset dependent dropdowns
    useEffect(() => {
        if (selectedXen?.id) {
            setManagerKeyAen((prev: any) => prev + 1)
            setManagerKeyJen((prev: any) => prev + 1)
            setSelectedAen({})
            setSelectedJen({})
        }
    }, [selectedXen])

    useEffect(() => {
        if (selectedAen?.id) {
            setManagerKeyJen((prev: any) => prev + 1)
            setSelectedJen({})
        }
    }, [selectedAen])

    // Fetch reports
    useEffect(() => {
        const filterData: any = {
            circle_id: circleId,
            xen_id: isAdmin ? selectedXen?.id : (xenId || selectedAen?.id || ''),
            aen_id: isAdmin ? selectedAen?.id : (aenId || selectedAen?.id || ''),
            jen_id: isAdmin ? selectedJen?.id : (selectedJen?.id || ''),
            search: search
        }
        dispatch(adminAction.getOldReportsList(filterData))
    }, [search, pageNo, selectedXen?.id, selectedAen?.id, selectedJen?.id, circleId, xenId, aenId, isAdmin, dispatch])

    // Load XEN options (only for Admin)
    const loadOptionsgetManagerXen = async (search: any, loadedOptions: any, { page }: { page: any }) => {
        const token: any = localStorage.getItem('kt-auth-react-v')
        const prefix = token ? JSON.parse(token)?.data?.prefix : '';
        const response = await fetch(
            `${URL.API_BASE_URL}/api/${prefix}/get_all_xen?search=${search}&page=${page}&circle_id=${circleId}`,
            {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token).api_token}`,
                },
            }
        )
        const responseJSON: PaginatedResponse = await response.json()
        const options = responseJSON?.results?.map((data: any) => ({
            value: data?.id,
            label: data?.name,
            ...data
        }))
        return {
            options,
            hasMore: responseJSON.has_more,
            additional: { page: page + 1 },
        }
    }

    // Load AEN options
    const loadOptionsgetManagerAen = async (search: any, loadedOptions: any, { page }: { page: any }) => {
        const token: any = localStorage.getItem('kt-auth-react-v')
        const id = isAdmin ? selectedXen?.id : xenId
        const prefix = token ? JSON.parse(token)?.data?.prefix : '';
        const response = await fetch(
            `${URL.API_BASE_URL}/api/${prefix}/get_department_child?search=${search}&page=${page}&id=${id}&circle_id=${circleId}`,
            {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token).api_token}`,
                },
            }
        )
        const responseJSON: PaginatedResponse = await response.json()
        const options = responseJSON?.results?.map((data: any) => ({
            value: data?.id,
            label: data?.name,
            ...data
        }))
        return {
            options,
            hasMore: responseJSON.has_more,
            additional: { page: page + 1 },
        }
    }

    // Load JEN options
    const loadOptionsgetManagerJen = async (search: any, loadedOptions: any, { page }: { page: any }) => {
        const token: any = localStorage.getItem('kt-auth-react-v')
        const parentId = isAdmin ? selectedAen?.id : (isXen ? selectedAen?.id : (isAen ? aenId : xenId))
        const prefix = token ? JSON.parse(token)?.data?.prefix : '';
        const response = await fetch(
            `${URL.API_BASE_URL}/api/${prefix}/get_department_child?search=${search}&page=${page}&id=${parentId}&circle_id=${circleId}`,
            {
                headers: {
                    Authorization: `Bearer ${JSON.parse(token).api_token}`,
                },
            }
        )
        const responseJSON: PaginatedResponse = await response.json()
        const options = responseJSON?.results?.map((data: any) => ({
            value: data?.id,
            label: data?.name,
            ...data
        }))
        return {
            options,
            hasMore: responseJSON.has_more,
            additional: { page: page + 1 },
        }
    }

    const handleViewFile = (fileUrl: string) => {
        if (fileUrl) {
            window.open(URL.API_BASE_URL + fileUrl, '_blank');
        }
    };

    const handleOldReportLogin = () => {
        const token: any = localStorage.getItem('kt-auth-react-v')

        if (!token) return

        const user = JSON.parse(token).data

        const url = `https://reportjaipurstaff.rrjtanker.com/auth?user_name=${user.user_name}&role_id=${user.role_id}&password=${user.password}`

        window.open(url, '_blank')
    };

    return (
        <div>
            <div className='d-flex flex-column flex-column-fluid'>
                <div id='kt_app_toolbar' className='app-toolbar py-3 py-lg-6'>
                    <div id='kt_app_toolbar_container' className='d-flex flex-stack container-xxl'>
                        <div className='d-flex flex-column flex-wrap me-3 page-title'>
                            <h1 className='my-0 fw-bold text-dark page-heading fs-3'>
                                Current Job
                            </h1>
                            <ul className='my-0 breadcrumb-separatorless pt-1 fw-semibold breadcrumb fs-7'>
                                <li className='breadcrumb-item text-muted'>
                                    <Link to={'/'} className='text-hover-primary text-muted'>
                                        Home
                                    </Link>
                                </li>
                                <li className='breadcrumb-item'>
                                    <span className='bg-gray-400 w-5px h-2px bullet'></span>
                                </li>
                                <li className='breadcrumb-item text-muted'> Current Job</li>
                            </ul>
                        </div>
                        <div className='d-flex align-items-center'>
                            <button
                                type='button'
                                className='btn btn-light-primary'
                                onClick={handleOldReportLogin}
                            >
                                <span className='svg-icon svg-icon-3 me-2'>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path opacity="0.3" d="M3 6C3 4.89543 3.89543 4 5 4H19C20.1046 4 21 4.89543 21 6V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V6Z" fill="currentColor" />
                                        <path d="M15 10L12 13L9 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <path d="M12 13V20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </span>
                                View Old Reports
                            </button>
                        </div>
                    </div>
                </div>

                <div id='kt_app_content' className='flex-column-fluid app-content'>
                    <div className='card card-flush'>
                        <div className='row'>
                            <div className='col-3'>
                                <div className='px-4 py-4'>
                                    <label className='form-label mb-2 fw-semibold fs-6'>
                                        <span>Search</span>
                                    </label>
                                    <input
                                        type='search'
                                        placeholder='Search by Name'
                                        className='form-control'
                                        onChange={(e: any) => {
                                            setSearch(e.target.value)
                                            setpageNo(1)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Conditional Dropdowns */}
                        <div className='row'>
                            {/* XEN Dropdown: Only for Admin */}
                            {isAdmin && (
                                <div className='col-3'>
                                    <div className='px-4 py-4'>
                                        <label className='form-label mb-2 fw-semibold fs-6'>
                                            <span>Select XEN</span>
                                        </label>
                                        <AsyncPaginate<any, any, any>
                                            key={managerKeyXen}
                                            value={selectedXen}
                                            loadOptions={loadOptionsgetManagerXen}
                                            onChange={(e: any) => {
                                                setSelectedXen(e)
                                                setpageNo(1)
                                            }}
                                            additional={{ page: 1 }}
                                            className='bg-transparent form-control'
                                            debounceTimeout={300}
                                            placeholder="Select XEN"
                                        />
                                    </div>
                                </div>
                            )}

                            {/* AEN Dropdown: Admin or XEN */}
                            {(isAdmin || isXen) && (
                                <div className='col-3'>
                                    <div className='px-4 py-4'>
                                        <label className='form-label mb-2 fw-semibold fs-6'>
                                            <span>Select AEN</span>
                                        </label>
                                        <AsyncPaginate<any, any, any>
                                            key={managerKeyAen}
                                            value={selectedAen}
                                            loadOptions={loadOptionsgetManagerAen}
                                            onChange={(e: any) => {
                                                setSelectedAen(e)
                                                setpageNo(1)
                                            }}
                                            additional={{ page: 1 }}
                                            className='bg-transparent form-control'
                                            debounceTimeout={300}
                                            placeholder="Select AEN"
                                        />
                                    </div>
                                </div>
                            )}

                            {/* JEN Dropdown: Admin, XEN, or AEN */}
                            {(isAdmin || isXen || isAen) && (
                                <div className='col-3'>
                                    <div className='px-4 py-4'>
                                        <label className='form-label mb-2 fw-semibold fs-6'>
                                            <span>Select JEN</span>
                                        </label>
                                        <AsyncPaginate<any, any, any>
                                            key={managerKeyJen}
                                            value={selectedJen}
                                            loadOptions={loadOptionsgetManagerJen}
                                            onChange={(e: any) => {
                                                setSelectedJen(e)
                                                setpageNo(1)
                                            }}
                                            additional={{ page: 1 }}
                                            className='bg-transparent form-control'
                                            debounceTimeout={300}
                                            placeholder="Select JEN"
                                        />
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className='pt-0 card-body' style={{ overflow: 'auto' }}>
                            <table className='table table-row-dashed mb-0 align-middle fs-6 gy-5'>
                                <thead className='table-light'>
                                    <tr>
                                        <th>S.NO.</th>
                                        <th>Name</th>
                                        <th>Date</th>
                                        <th>Circle</th>
                                        <th>XEN</th>
                                        <th>AEN</th>
                                        <th>JEN</th>
                                        <th>File</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportData.length > 0 ? (
                                        reportData.map((item: any, index: any) => (
                                            <tr key={index}>
                                                <td>{(pageNo - 1) * 10 + index + 1}</td>
                                                <td>{item?.name}</td>
                                                <td>{item?.date}</td>
                                                <td>{item?.circle?.name || '-'}</td>
                                                <td>{item?.xen?.name || '-'}</td>
                                                <td>{item?.aen?.name || '-'}</td>
                                                <td>{item?.jen?.name || '-'}</td>
                                                <td>
                                                    {item?.file ? (
                                                        <button
                                                            onClick={() => handleViewFile(item.file)}
                                                            className="btn btn-sm btn-success"
                                                        >
                                                            <i className="fas fa-file-pdf"></i>
                                                        </button>
                                                    ) : '-'}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={8} className="text-center py-8">
                                                <h3>Record Not Found</h3>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            {totalDocs > 10 && (
                                <ReactPaginate
                                    breakLabel='...'
                                    nextLabel='next >'
                                    className='dataTables_paginate paging_simple_numbers category'
                                    onPageChange={handlePageClick}
                                    pageRangeDisplayed={2}
                                    pageCount={pageCount}
                                    previousLabel='< previous'
                                    forcePage={pageNo - 1}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OldReports;